import '@vfde-brix/image-text/dist/styles.css';
import { createImageTextComponent } from '@vfde-brix/image-text';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-image-text', createImageTextComponent, NO_PATTERN_BUSINESS_LOGIC);
